import { memo, useMemo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    WorkspaceAvatarGroup,
    type WorkspaceAvatarGroupItem,
} from "@components/avatar/WorkspaceAvatarGroup";
import { EmptyCell } from "@components/history/views/cells/EmptyCell";
import { useOrganizationClients } from "../useOrganizationClients";

export interface OrganizationActivityClientsRow {
    clientWorkspaceIds: string[];
}

interface ClientsCellProps {
    row: { original: OrganizationActivityClientsRow };
}

export const ClientsCell = memo(({ row }: ClientsCellProps) => {
    const { data: workspacesList } = useOrganizationClients();
    const { clientWorkspaceIds } = row.original;

    const workspaces = useMemo<WorkspaceAvatarGroupItem[]>(() => {
        if (clientWorkspaceIds.length === 0 || !workspacesList) {
            return [];
        }
        const workspacesById = new Map(
            workspacesList.map((workspace) => [workspace.id, workspace]),
        );
        return clientWorkspaceIds.flatMap((id) => {
            const workspace = workspacesById.get(id);
            return workspace ? [{ workspace }] : [];
        });
    }, [clientWorkspaceIds, workspacesList]);

    if (workspaces.length === 0) {
        return <EmptyCell />;
    }

    return (
        <ViewTableCell>
            <WorkspaceAvatarGroup workspaces={workspaces} max={3} size="xs" />
        </ViewTableCell>
    );
});

ClientsCell.displayName = "ClientsCell";
